import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { formatDate } from "utils/date";

import ExternalLinkIcon from "assets/external-link-icon.inline.svg";
import { PageSection } from "components/PageSection";
import { BodyText } from "styles";

import { ImageWrapper, PostTitle } from "./PostsGrid.styles";

type Props = {
  posts: Queries.AllPostsQuery["allSanityPost"]["nodes"];
};

export const PostsGrid = ({ posts }: Props) => {
  return (
    <PageSection variant="thirds">
      {posts.map((post) => {
        const isExternal = post.isExternal && post.externalUrl;
        const postUrl = isExternal
          ? post.externalUrl
          : `/posts/${post.slug?.current}`;

        const LinkComponent = isExternal ? "a" : Link;
        const image = post?.image?.asset ? getImage(post.image.asset) : null;

        return (
          <LinkComponent
            //@ts-ignore
            to={isExternal ? undefined : postUrl}
            href={isExternal ? postUrl : undefined}
            target={isExternal ? "_blank" : undefined}
            key={post.slug?.current}
            className="mb-20"
          >
            <ImageWrapper>
              {image && (
                <GatsbyImage
                  className="max-h-[240px] w-full rounded-lg"
                  image={image}
                  alt={post.title || "image"}
                />
              )}
            </ImageWrapper>
            <PostTitle $variant="b3reg" className="pt-8">
              {post.title}
            </PostTitle>
            <BodyText $variant="b4reg">{post.subtitle}</BodyText>
            <div className="mt-2 flex flex-1 items-center justify-between">
              <BodyText $hasPadding={false} $variant="b5reg">
                {formatDate(post.date)}
              </BodyText>
              {isExternal && (
                <BodyText
                  as="div"
                  $variant="b5reg"
                  $hasPadding={false}
                  className="flex gap-x-2"
                >
                  External <ExternalLinkIcon />
                </BodyText>
              )}
            </div>
          </LinkComponent>
        );
      })}
    </PageSection>
  );
};
